<template>
  <b-tab :title="name" title-link-class="text-info">
    <b-row>
      <b-col>
        <b-table striped hover responsive
                 v-if="cases.length > 0"
                 :items="cases"
                 :fields="fields"
                 :per-page="perPage"
                 :current-page="currentPage"
        >
          <template v-slot:thead-top="data">
            <b-tr style=" text-align: center">
              <b-th colspan="5" style="color: #2DA1A9">คำสั่ง</b-th>
              <b-th colspan="4" style="border-left: 1px solid #2DA1A9;color: #2DA1A9">เหตุการณ์</b-th>
              <b-th colspan="2" style="border-left: 1px solid #2DA1A9;color: #2DA1A9">ผู้เสียชีวิต</b-th>
              <b-th colspan="3" style="border-left: 1px solid #2DA1A9;color: #2DA1A9">จุดเกิดเหตุ</b-th>
            </b-tr>
          </template>

          <template v-slot:cell(report)="data">
            <div class="text-center">
              <button style="background: transparent; border: 0;" class="my-md-auto"
                      v-b-modal.print
                      @click="info(data.item, data.index, 'ok',false)">
                <img class="my-md-1" src="../assets/report.png" style="width: 18px;">
              </button>
            </div>
          </template>
          <template v-slot:cell(request)="data">
            <div class="text-center">
              <button style="background: transparent; border: 0;" class="my-md-auto"
                      @click="onGetExportRequisition(data)">
                <img class="my-md-1" src="../assets/req.png" style="width: 18px;">
              </button>
            </div>
          </template>
          <template v-slot:cell(refer)="row">
            <div class="text-center">
              <b-button v-if="!row.item.refer_id"
                        size="sm" style="color: #fff;"
                        @click="info(row.item, row.index,)">
                Refer
              </b-button>

              <button v-else style="background: transparent; border: 0;" class="my-md-auto" @click="onGetExportRefer(row)">
                <img class="my-md-1" src="../assets/report.png" style="width: 15px;height: auto">
                <div style="font-size: 12px">{{row.item.refer_id}}</div>
              </button>
            </div>
          </template>
          <template v-slot:cell(status_id)="row">
            <div class="text-center">
              <div v-if="row.item.status_id == 'Approve' ">
                <p style="color:forestgreen"><b>{{row.item.status_id}}</b></p>
              </div>
              <div v-if="row.item.status_id == 'Open' ">
                <!--            <a @click="test(row.item.status_id)" style="color: crimson"><u><b>{{row.item.status_id}}</b></u></a>-->
                <a v-b-modal.status @click="info(row.item, row.index, 'ok',false)" style="color: crimson"><u><b>{{row.item.status_id}}</b></u></a>
              </div>
            </div>
          </template>
          <template v-slot:cell(address_province_id)="row">
            {{row.item.provinces? row.item.provinces.name:'-'}}
          </template>
          <template v-slot:cell(address_district_id)="row">
            {{row.item.districts? row.item.districts.name:'-'}}
          </template>
          <template v-slot:cell(address_sub_district_id)="row">
            {{row.item.subdistricts? row.item.subdistricts.name:'-'}}
          </template>
          <template v-slot:cell(edit)="data">
            <button @click="onOpenEdit(data)" style="background: transparent; border: 0;" class="my-md-auto">
              <img class="my-md-1" src="../assets/edit.png" style="width: 20px;">
            </button>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-modal
        id="print"
        style="width: 100%"
        ref="modal-print"
        title="ต้องการรูปภาพประกอบด้วยหรือไม่"
        @hidden="resetModal"
    >
      <b-form ref="modal-print">
        <input type="checkbox" size="sm" id="pictureReportPrint" v-model="checkPicture" >&nbsp
        <label for="pictureReportPrint" class="radio-label"><b style="color: #17a2b8">ต้องการรูป</b>
        </label>
      </b-form>
      <template v-slot:modal-footer="{ ok, cancel,hidden}">
        <b-button size="sm" variant="outline-danger" @click="cancel()">
          cancel
        </b-button>
        <b-button size="sm" variant="outline-success" @click="onGetExportSubmission">
          Ok
        </b-button>

      </template>
    </b-modal>
    <b-modal
        id="status"
        style="width: 100%"
        ref="modal-status"
        title="ต้องการอนุมัติรายงานหรือไม่?"
        @hidden="resetModal"
    >
      <b-form ref="modal-status">
        <input type="checkbox" size="sm" id="changeStatus" v-model="checkStatus" >&nbsp
        <label for="changeStatus" class="radio-label"><b style="color: #17a2b8">ยืนยันการอนุมัติ</b>
        </label>
      </b-form>
      <template v-slot:modal-footer="{ ok, cancel,hidden}">
        <b-button size="sm" variant="outline-danger" @click="cancel()">
          ยกเลิก
        </b-button>
        <b-button size="sm" variant="outline-success" @click="onChangeStatus()">
          ตกลง
        </b-button>

      </template>
    </b-modal>
    <b-modal :id="infoModal.id" :title="infoModal.title"  hide-footer>
      <div class="row" style="padding: 40px;justify-content: center">
        <div class="d-block text-center mb-5 col-12">
          <multiselect class="multiselect-style2"
                       v-model="valueHospital"
                       :options="optionHospital"
                       label="name"
                       select-label=""
                       selectedLabel=""
                       deselect-label=""
                       placeholder="เลือกโรงพยาบาล"
                       track-by="name"

          />
        </div>
        <!--                    <div class="col-6">-->
        <!--                        <b-button class="email-button" style="color: #2DA1A9;font-size: 17px" @click="">ยกเลิก</b-button>-->
        <!--                    </div>-->
        <div class="col-6">
          <b-button class="autopsy-button" style="font-size: 17px" block @click="refer_to_other">Refer</b-button>
        </div>
      </div>
    </b-modal>
    <b-pagination  v-if="cases.length > 0"
                   v-model="currentPage"
                   :total-rows="cases.length"
                   :per-page="perPage"
                   aria-controls="my-table"
                   first-number
                   last-number
                   align="right"
    ></b-pagination>
  </b-tab>
</template>

<script>
import {mapState} from "vuex";
import Service from "../service";
import moment from "moment";
var fieldsStyle = {
  thStyle: {color: '#616161', 'text-align': 'center'},
};
export default {
  props: ['name','tabIndex','cases','idx'],
  name: "TabData",
  data() {
    return {
      checkStatus:false,
      checkPicture:false,
      valueHospital: '',
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      },
      perPage: 10,
      currentPage: 1,
      fields: [
        {
          key: 'report',
          label: 'รายงาน',
          sortable: false,
          ...fieldsStyle
        },
        {
          key: 'request',
          label: 'ใบเบิก',
          sortable: false,
          ...fieldsStyle
        },
        {
          key: 'refer',
          label: 'Refer',
          sortable: true,
          ...fieldsStyle
        },
        {
          key: 'status_id',
          label: 'สถานะ',
          sortable: true,
          ...fieldsStyle
        },
        {
          key: 'edit',
          label: 'แก้ไข',
          sortable: false,
          ...fieldsStyle
        },
        {
          key: 'event_id',
          label: 'รหัสเหตุการณ์',
          sortable: true,
          ...fieldsStyle,
        },
        {
          key: 'case_id',
          label: 'เลขที่ชันสูตร',
          sortable: true,
          ...fieldsStyle,
        },
        {
          key: 'doc_id',
          label: 'เลขที่เอกสาร',
          sortable: true,
          ...fieldsStyle,
        },
        {
          key: 'received_case_date',
          label: 'วันที่เกิดเหตุ',
          sortable: true,
          formatter: (value, key, item) => {
            return value ? moment(value).add(543, 'y').format('DD/MM/YYYY') : null
          },
          ...fieldsStyle
        },
        {
          key: 'dead_gender',
          label: 'เพศ',
          sortable: true,
          ...fieldsStyle
        },
        {
          key: 'dead_age',
          label: 'อายุ',
          sortable: true,
          ...fieldsStyle
        },
        {
          key: 'location_province_id',
          label: 'จังหวัด',
          sortable: true,
          ...fieldsStyle
        },
        {
          key: 'location_district_id',
          label: 'อำเภอ',
          sortable: true,
          ...fieldsStyle
        },
        {
          key: 'location_sub_district_id',
          label: 'ตำบล',
          sortable: true,
          ...fieldsStyle
        }
      ],
      optionHospital:[],
      selectedRow: null
    }
  },
  created() {
    Service.Hospital.getHospital()
        .then(data=>{
          this.optionHospital = data;
        })
  },
  computed: {
    ...mapState({
      users: state=>{
        return state.Auth.users;
      },
    })
  },
  methods:{
    async onOpenEdit(data) {
      this.$swal.fire({
        title: 'กำลังจัดเตรียมข้อมูล',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          this.$swal.showLoading()
        },
      });

      let caseid = data.item
      await this.$store.dispatch("Eventform/clearFormData");
      await this.$store.dispatch("Eventform/onGetCaseID",caseid);
      await this.$store.dispatch("Eventform/onGetAppearancesID",caseid);
      await this.$store.dispatch("Eventform/onGetEvidence",caseid);
      await this.$store.dispatch("Eventform/onGetTransformationID",caseid).then(()=>{
        const path = `/question-form/1`
        this.$swal.close();
        if (this.$route.path !== path) this.$router.push(path)
      });
    },
    onTableRefers() {
      this.onTableRefer = true;
      console.log('สถานะTable',this.onTableRefer)
    },
    offTableRefers() {
      this.onTableRefer = false;
      console.log('สถานะTable',this.onTableRefer)
    },
    linkClass() {
      if (this.tabIndex === this.idx) {
        return ['bg-light', 'text-info']
      } else {
        return ['text-info' ]
      }
    },
    async onGetExportSubmission(){

      // let export_id = data.item;
      let data ={
        id : this.selectedRow.id,
        picture: this.checkPicture,
      }
      // alert(data.picture)
      await   this.$store.dispatch("Eventform/onGetExportSubmission",data)
      await   this.$ga.event("Export/SubmissionPDF","Eventform/onGetExportSubmission","SubmissionPDF")
      await  this.hideModal('modal-print')
      await this.resetModal()
    },
    hideModal(modalName) {
      this.$refs[modalName].hide()
    },
    resetModal(){
      this.checkPicture=false;
      this.checkStatus=false;
    },
    onGetExportRequisition(data){
      let export_id = data.item;
      this.$store.dispatch("Eventform/onGetExportRequisition",export_id);
      this.$ga.event("Export/RequisitionPDF","Eventform/onGetExportRequisition","RequisitionPDF")

    },
    onGetExportRefer(data){
      let export_id = data.item;
      console.log('refer', export_id)
      this.$store.dispatch("Eventform/onGetExportRefer",export_id);
      this.$ga.event("Export/ReferPDF","Eventform/onGetExportRefer","ReferPDF")

    },
    info(item, index, button, isRefer = true) {
      this.selectedRow = item;
      if(isRefer){
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      }
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
      this.$root.$emit('bv::hide::modal', button)
    },
    async refer_to_other(data) {
      // console.log('refer!',data)
      let obj = {
        id: this.selectedRow.id,
        item: { hospcode : this.valueHospital.hospcode, refer_by: this.users.hospcode, refer_user: this.users.id }
      }
      console.log('refer!!',obj)

      await this.$store.dispatch("Eventform/refer",obj).then(()=>{
        this.selectedRow = null;
        this.valueHospital = '';
        this.$store.dispatch("Eventform/onGetCaseSituation");
        this.$store.dispatch("Eventform/onGetCaseHospital");
      });
      this.$root.$emit('bv::hide::modal', this.infoModal.id)
    },
  async  onChangeStatus(){
      if (this.checkStatus != false){
        let data ={
          id : this.selectedRow.id,
          picture: this.checkStatus,
        }
        await   this.$store.dispatch("Eventform/onChangeStatus",data)
        await  this.hideModal('modal-status')
        await this.resetModal()
        await this.$store.dispatch("Eventform/onGetCaseSituation");
        await this.$store.dispatch("Eventform/onGetCaseHospital");
      }

    }
  }
}
</script>

<style scoped>
</style>
